export default __webpack_public_path__ + "static/media/ic-picture.e541ed8a.svg";